export default __webpack_public_path__ + "static/media/hoppia_events_01.d19f0d5f.png";